var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useMemo } from "react";
import styled from "styled-components";
import { KanbanCard } from "./card";
import { KanbanPanel } from "./panel";
var Board = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var theme = _a.theme, numPanels = _a.numPanels;
    return "\n    background-color: ".concat(theme.bgContent2(), ";\n    display: grid;\n    grid-template-columns: repeat(").concat(numPanels, ", 250px);\n    grid-template-rows: 1fr;\n    width: 100%;\n    height: 100%;\n    overflow: scroll;\n    overflow: overlay;\n    grid-gap: .5rem;\n  ");
});
export var KanbanBoard = function (_a) {
    var panels = _a.panels, cards = _a.cards;
    var CARDS = useMemo(function () {
        var cardsMap = {};
        Object.entries(cards).forEach(function (_a) {
            var id = _a[0], card = _a[1];
            if (Array.isArray(cardsMap[card.tag])) {
                cardsMap[card.tag].push(React.createElement(KanbanCard, __assign({ key: id }, card, { width: "100%" })));
            }
            else {
                cardsMap[card.tag] = [React.createElement(KanbanCard, __assign({ key: id }, card, { width: "100%" }))];
            }
        });
        return cardsMap;
    }, [cards]);
    var PANELS = useMemo(function () {
        return panels.map(function (panel) { return (React.createElement(KanbanPanel, __assign({ key: panel.id }, panel), panel.tags.map(function (tag) { return CARDS[tag]; }))); });
    }, [panels, CARDS]);
    return React.createElement(Board, { numPanels: PANELS.length }, PANELS);
};
var templateObject_1;
